import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useSiteConfig, getWhatsAppUrl } from '@/lib/siteConfig';

const pageMessages = {
  '/': 'Hola, quiero conocer las soluciones ALLCOM',
  '/soluciones': 'Hola, necesito información sobre soluciones ALLCOM',
  '/hardware': 'Hola, quiero cotizar hardware',
  '/software': 'Hola, me interesa el software ALLCOM',
  '/servicios': 'Hola, necesito información sobre servicios',
  '/servicios/piloto': 'Hola, quiero solicitar un piloto de 30 días',
  '/servicios/arriendo-leasing': 'Hola, quiero cotizar arriendo de equipos',
  '/contacto': 'Hola, necesito cotizar',
};

export const WhatsAppFAB = () => {
  const location = useLocation();
  const { whatsapp_number } = useSiteConfig();
  const message = pageMessages[location.pathname] || 'Hola, necesito información sobre sus soluciones';
  const url = getWhatsAppUrl(whatsapp_number, message);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-50 flex items-center justify-center w-14 h-14 bg-emerald-500 hover:bg-emerald-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all whatsapp-pulse group"
      data-testid="whatsapp-floating-button"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="absolute right-full mr-3 px-3 py-1.5 text-sm font-medium bg-white text-slate-900 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        ¿Necesitas ayuda?
      </span>
    </a>
  );
};

export default WhatsAppFAB;
